/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any */
import { createFileRoute, useParams } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { motion } from 'framer-motion'
import { StickyNote, CreditCard, CheckCircle2 } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { jobsAPI } from '@/lib/api/jobs'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_authenticated/jobs/$jobId/notes')({
  component: JobNotesTab,
})

function JobNotesTab() {
  const { t } = useTranslation()
  const { jobId } = useParams({ from: '/_authenticated/jobs/$jobId' })
  const { data: job } = useQuery({
    queryKey: ['job', jobId],
    queryFn: () => jobsAPI.get(jobId),
  })

  const j = job as any
  if (!j) return null

  return (
    <motion.div
      initial={{ opacity: 0, x: 10 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.15 }}
      className="space-y-4"
    >
      <div className="grid gap-4 md:grid-cols-2">
        {j.special_instructions && (
          <Card>
            <CardHeader className="pb-3">
              <CardTitle className="text-base flex items-center gap-2">
                <StickyNote className="w-4 h-4 text-amber-500" /> Special Instructions
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm whitespace-pre-wrap">{j.special_instructions}</p>
            </CardContent>
          </Card>
        )}
        {j.payment_instructions && (
          <Card>
            <CardHeader className="pb-3">
              <CardTitle className="text-base flex items-center gap-2">
                <CreditCard className="w-4 h-4 text-green-500" /> Payment Instructions
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm whitespace-pre-wrap">{j.payment_instructions}</p>
            </CardContent>
          </Card>
        )}
        {j.completion_notes && (
          <Card>
            <CardHeader className="pb-3">
              <CardTitle className="text-base flex items-center gap-2">
                <CheckCircle2 className="w-4 h-4 text-green-500" /> {t('jobDetail:completionNotes')}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm whitespace-pre-wrap">{j.completion_notes}</p>
            </CardContent>
          </Card>
        )}
      </div>
      {!j.special_instructions && !j.payment_instructions && !j.completion_notes && (
        <Card>
          <CardContent className="py-12 text-center text-muted-foreground">
            No notes or instructions for this job
          </CardContent>
        </Card>
      )}
    </motion.div>
  )
}
